import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = {
    acknowledged: Boolean
  }

  disconnect() {
    this.toggleScrollLock(false, true)
  }

  check(event) {
    // If it's a radio button change
    if (event.target.value === "in_person" && !this.acknowledgedValue) {
      this.openModal()
    }
  }

  handleSubmit(event) {
    const deliveryMethod = document.querySelector('input[name="service[delivery_method]"]:checked')?.value
    if (deliveryMethod === "in_person" && !this.acknowledgedValue) {
      event.preventDefault()
      this.openModal()
    }
  }

  openModal() {
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    this.toggleScrollLock(true)
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    this.toggleScrollLock(false)
    
    // Switch back to online if they closed the modal without agreeing
    const onlineRadio = document.querySelector('input[value="online"]')
    if (onlineRadio) onlineRadio.checked = true
    
    // Trigger the location toggle to hide fields
    const locationToggle = document.querySelector('[data-controller="location-toggle"]')
    if (locationToggle) {
      const event = new Event('change')
      onlineRadio.dispatchEvent(event)
    }
  }

  toggleScrollLock(lock, force = false) {
    const body = document.body
    const html = document.documentElement
    let openModals = parseInt(body.dataset.openModals || "0")

    if (lock) {
      openModals++
      body.dataset.openModals = openModals
      
      if (openModals === 1) {
        this.scrollPos = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.scrollPos}px`
        body.style.width = '100%'
        body.classList.add('overflow-hidden')
        html.classList.add('overflow-hidden')
      }
    } else {
      openModals = force ? 0 : Math.max(0, openModals - 1)
      body.dataset.openModals = openModals
      
      if (openModals === 0) {
        const scrollY = body.style.top
        body.style.position = ''
        body.style.top = ''
        body.style.width = ''
        body.classList.remove('overflow-hidden')
        html.classList.remove('overflow-hidden')
        if (!force) {
          window.scrollTo(0, parseInt(scrollY || '0') * -1)
        }
      }
    }
  }
}
